import { useState } from 'react';

function useValidationState(array) {
    const [validationState, setValidationState] = useState(() => {
        const object = {};
        array.forEach(elem => {
            if (elem.type === 'devided') {
                elem.devidedInputs.forEach((el) => {
                    object[el.name] = true;
                });
            } else {
                object[elem.name] = true;
            }
        });
        return object;
    });
    return [validationState, setValidationState];
};

export default useValidationState;